<!--
    描述： 附件名称 可预览、可下载
    创建时间： 2022-04-12 08:36:24
    作者： Wang Shuai
    邮箱： 591372242@qq.com
-->
<template>
  <div class="file-name-layout">
    <el-dropdown placement="bottom-start" @command="handleClick" size="small">
      <span class="el-dropdown-link">{{ fileName }}</span>
      <el-dropdown-menu slot="dropdown">
        <template v-if="filePath !== ''">
          <el-dropdown-item
            command="preview"
            v-if="isShowPreview && !onlyDownload"
          >
            预览
          </el-dropdown-item>
          <el-dropdown-item command="download" v-if="downLoad">
            下载
          </el-dropdown-item>
        </template>
        <el-dropdown-item command="delete" v-show="showRemove">
          删除
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    // 附件名称
    fileName: {
      type: String,
      default: ""
    },
    // 附件地址
    filePath: {
      type: String,
      default: ""
    },
    onlyDownload: {
      type: Boolean,
      default: false
    },
    fileSize: {
      type: String,
      default: ""
    },
    // 是否显示删除
    showRemove: {
      type: Boolean,
      default: false
    },
    // 是否显示下载
    downLoad: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    // 点击预览、下载
    handleClick(type) {
      let uploadUrl = process.env.VUE_APP_UPLOAD_URL;

      if (type === "preview") {
        this.$emit("doView");
      } else if (type === "delete") {
        this.$emit("doDelete");
      } else {
        window.open(uploadUrl + this.filePath, "_blank");
      }
    }
  },
  computed: {
    // 是否显示预览
    isShowPreview() {
      let arr = this.fileName.split(".");
      let fileFormat = arr[arr.length - 1];
      // 如果是可预览的文件类型
      return this.viewAcceptType.includes(fileFormat.toUpperCase());
    },

    // 可预览格式
    viewAcceptType() {
      return [
        "JPG",
        "JPEG",
        "PNG",
        "PDF",
        "GIF",
        "EXCEL",
        "DOC",
        "DOCX",
        "TXT",
        "XLS",
        "XLSX",
        "PPT",
        "PPTX",
        "XML",
        "DWG"
      ];
    },

    // 预览环境变量
    previewUrl() {
      return process.env.VUE_APP_PREVIEW_URL;
    }
  }
};
</script>

<style scoped lang="less">
.file-name-layout {
  display: inline-block;
  color: #1a9ed8;
  cursor: pointer;
  margin-left: 5px;

  i {
    vertical-align: middle;
  }
}
</style>
